// extracted by mini-css-extract-plugin
export default {"form":"SchoolSummaryView_form__MPwTN","heading":"SchoolSummaryView_heading__mgvdd","summary":"SchoolSummaryView_summary__vKiDS","box":"SchoolSummaryView_box__qFGev"};